import { render, staticRenderFns } from "./teaching-resources.vue?vue&type=template&id=3601fd5e"
import script from "./teaching-resources.vue?vue&type=script&setup=true&lang=ts"
export * from "./teaching-resources.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports